









import { container } from 'tsyringe';
import { defineComponent, ref, watch } from '@vue/composition-api';
import ViewContainer from '@/components/ViewContainer.vue';
import { ModelManager } from '@/prototyping/model';
import { messenger } from '@/messenger';

export default defineComponent({
  components: { ViewContainer },
  name: 'Unlock Vinylpostcard',
  setup(_props, ctx) {
    const modelManager = container.resolve(ModelManager);
    const audioPlayer = modelManager.get('audio-player', 'AudioPlayerModel');
    const audioLib = modelManager.get('audio-lib', 'StoryblokAudioLibModel');
    const imageTargetTracks = modelManager.get('image-target-tracks', 'StoryblokImageTargetTracksLibModel');
    const vinylpostcards = modelManager.get('vinylpostcards', 'VinylPostcardsModel');

    const code = ref('');
    const failed = ref(false);

    function unlockAudioTracks(e) {
      console.log('***', code.value)

      if (code.value) {
        if (vinylpostcards.stopAudioPlayerAndAddNewSongsFromUnlockCode(code.value, audioPlayer, audioLib, imageTargetTracks)) {
          code.value = '';
          messenger.unity?.core.saveSerializedAppState();

          ctx.root.$router.replace('/');
        } else {
          failed.value = true;
        }
      }

      e.preventDefault();
      return false;
    }

    watch(() => failed.value, () => {
      if (!failed.value) return;

      setTimeout(() => {
        failed.value = false;
      }, 250);
    }, {
      immediate: true
    });

    return {
      unlockAudioTracks,
      code,
      failed,
    };
  },
});
